import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography, Alert } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { CURRENT_PATH } from "utils/constants";

const useStyles = makeStyles((theme: any) => ({
  alert: {
    width: "100%", marginBottom: "1rem"
  },
  alertLink: {
    fontWeight: 'bold',
    textDecoration: 'none',
    borderBottom: '1px dotted',
    color: theme.palette.secondary.main,
    whiteSpace: "nowrap"
  },
  alertLinkIcon: { marginLeft: theme.spacing(0.7) },
}));

export const VerifyAttendeesAlert = () => {
  const { id } = useParams<{ id: string }>();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Alert severity="info" className={classes.alert}>
      <Typography>
        {t('ron:verify-attendees-message')}
        {' '}
        <Link
          to={`/orders/details/${id}/parties/`}
          className={classes.alertLink}
          onClick={() => {
            localStorage.setItem(
              CURRENT_PATH,
              JSON.stringify({ view: 'parties' })
            );
          }}
        >
          {t('ron:parties-link')}
          <FontAwesomeIcon
            icon="link"
            className={classes.alertLinkIcon}
          />
        </Link>
        {' '}
        {t('ron:screen-suffix')}
      </Typography>
    </Alert>
  );
};
